import './Dashboard.css';

import { checkScreenSize, dashboardData, clearDashboardData, closeSettingSystemNotificationsNotification } from '../../stores/actions/dashboardActions';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { closeNoMeasurementsWarning } from '../../stores/actions/exportActions';
import { closeNodeRecalculatedNotification, closeNodeWillRecalculateNotification, closeNodeAcceleratedNotification, 
	     closeAcceleratedNodesNotification, 
		 closeSettingRainstormModeNotification, 
		 closeSettingServiceModeNotification,
		 closeSendTestNotificationNotification, closeResetSensorErrorCountsNotification} from '../../stores/actions/installerActions';
import { connect } from 'react-redux';
import { ENDPOINT_DEVICE, INFRASTRUCTURE_DEVICES } from '../../helpers/Devices';
import { INode, ISystemSettings } from '../../helpers/interfaces';
import { colorMap } from '../../helpers/GlobalVariables';
import { loaderStyleEmptyCard, parseMapBoundaries } from '../../helpers/CustomStyles';
import { setCurrentNodeID } from '../../stores/actions/actions';
import Card from '../../../components/Card/CardTS';
import CardFooter from '../../../components/Card/CardFooterTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import dashboardStyle from '../../../assets/jss/material-dashboard-pro-react/views/dashboardStyleTS';
import EmptyCard from '../../components/EmptyCard/EmptyCard.jsx';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import ErrorText from '../../components/ErrorComponent/ErrorText';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import HeatMap from '../../components/HeatMap/HeatMap';
import Map from '@material-ui/icons/Map';
import MapLoading from './MapLoading';
import NodeCards from './NodeCards';
import React from 'react';
import ShortStatus from '../../components/ShortStatus/ShortStatusTS';
import Snackbar from '../../../components/Snackbar/Snackbar';
import WiseneCardIcon from '../../components/WiseneCardIcon/WiseneCardIcon';
import { withRouter } from "react-router";
import { accelerateNode } from '../../stores/actions/nodeActions.js';

interface IDashboardProps {
	isMapLoading: boolean;
	isNodesLoading: boolean;
	isNodeLoading: boolean;
	isEditing: boolean;
	systemMapDataBlob: string;
	measurementsLoading: boolean;
	measurementsRange: number;
	measurementsPage: number;
	nodes: INode[];
	node: INode;
	system: ISystemSettings;
	noMeasurementsWarnings: number[];
	mobileView: boolean;
	classes: ClassNameMap;
	dashboardFilteredNodes: number[];
	deleteNodeSuccessfully: boolean;
	forbidden: boolean;
    accelerateSucceeded: boolean;
    nodeAcceleratedUntil: string;
	acceleratedNodes: boolean;
	systemFiles: any;
	rainstormModeSettingSuccess: boolean;
	rainstormModeSettingFailed: boolean;
	rainstormModeSettingFailedReason: string;
	serviceModeSettingFailed: boolean;
	serviceModeSettingSuccess: boolean;
	testNotificationFailed: boolean;
	testNotificationSuccess: boolean;
	settingNotificationsSuccess: boolean;
	settingNotificationsFailed: boolean;
	resetSensorErrorCountsSuccess: boolean;
	resetSensorErrorCountsFailed: boolean;
	dashboardData: () => void;
	clearDashboardData: () => void;
	setCurrentNodeID: (nodeId: number) => void;
	closeNoMeasurementsWarning: (nodeId: number) => void;
	checkScreenSize: (isMobileView: boolean) => void;
	closeSettingSystemNotificationsNotification: () => void;
	closeResetSensorErrorCountsNotification: () => void;
}

interface IDashboardState {
	exportStart: string;
	exportStop: string;
	wasNodeDeleted: boolean;
	invalidParam: boolean;
}

class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
	state = {
		exportStart: '',
		exportStop: '',
		wasNodeDeleted: this.props.deleteNodeSuccessfully,
		invalidParam: false
	};
	warningTimeout: ReturnType<typeof setTimeout> = null;
	interval: ReturnType<typeof setTimeout> = null;

	componentWillMount() {
	    this.props.clearDashboardData();
	    const param = this.props.match?.params?.id;
        if (param) {
            const systemId = parseInt(param);
            if (!isNaN(systemId)) {
                this.props.dashboardData(systemId);
            } else {
                this.setState({ invalidParam: true })
            }
        }
	}

	componentDidMount() {
		window.addEventListener('resize', () => this.props.checkScreenSize(this.props.mobileView));
		this.setState((prevState) => ({ ...prevState, wasNodeDeleted: this.props.deleteNodeSuccessfully }));
	}

	componentDidUpdate(prevProps, prevState) {
		this.props.checkScreenSize(this.props.mobileView);
		if (!this.state.exportStart && this.props.system?.ID === parseInt(this.props.match.params.id)) {
		    this.getExportDates();
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
		window.removeEventListener('resize', () => this.props.checkScreenSize(this.props.mobileView));
		clearTimeout(this.warningTimeout);
	}

	getExportDates = () => {
		let system = this.props.system;

		let exportStart = system.winterSeasonStart === undefined ? '01.11' : system.winterSeasonStart;
		let exportStartYear: string;
		let exportStartMonth = exportStart.split('.')[1];
		let exportStartDay = exportStart.split('.')[0];

		let today = new Date().toISOString().split('T')[0].split('-');
		let todayYear = today[0];
		let todayMonth = today[1];
		let todayDay = today[2];
		if (todayMonth > exportStartMonth || (todayMonth === exportStartMonth && todayDay >= exportStartDay)) {
			exportStartYear = todayYear;
		} else {
			exportStartYear = (parseInt(todayYear) - 1).toString();
		}

		this.setState({
			exportStart: `${exportStartYear}-${exportStartMonth}-${exportStartDay}T00:00:00`,
			exportStop: `${todayYear}-${todayMonth}-${todayDay}T23:59:59`,
		});
	};

	render() {
		const {
			classes,
			isNodesLoading,
			isMapLoading,
			noMeasurementsWarnings,
			closeNoMeasurementsWarning,
			closeNodeRecalculatedNotification,
			closeNodeWillRecalculateNotification,
			closeNodeAcceleratedNotification,
			closeAcceleratedNodesNotification,
			mobileView,
			dashboardFilteredNodes,
			forbidden,
			isRecalculated,
			nodes,
			systemMapDataBlob,
			accelerateSucceeded,
			nodeAcceleratedUntil,
			acceleratedNodes,
			systemFiles,
			rainstormModeSettingSuccess,
			rainstormModeSettingFailed,
			rainstormModeSettingFailedReason,
			serviceModeSettingFailed,
			serviceModeSettingSuccess,
			testNotificationFailed,
			testNotificationSuccess,
			settingNotificationsSuccess,
			settingNotificationsFailed,
			resetSensorErrorCountsSuccess,
			resetSensorErrorCountsFailed,
			system,
			closeSettingRainstormModeNotification,
			closeSendTestNotificationNotification,
			closeSettingServiceModeNotification,
			closeSettingSystemNotificationsNotification,
			closeResetSensorErrorCountsNotification
		} = this.props;
		try {
			console.log('testNotificationFailed, testNotificationSuccess', testNotificationFailed, testNotificationSuccess);
		    if (forbidden || this.state.invalidParam) {
		        return <div  style={{ padding: "10px", ...loaderStyleEmptyCard }}>403</div>;
		    }

		    if (this.props.system?.ID !== parseInt(this.props.match.params.id)) {
		        return <MapLoading />
		    }
			const currentSystem = this.props.system;
			let measuringDevices = [];
			let infrastructureDevices = [];
			let nonoperationalDevices = [];
			let unknownDevices = [];
			let acceleratedNodesNames = [];
			nodes.forEach((node: INode) => {
				if (node.SystemVersion == 'W2' && !node.W2Operational) {
					nonoperationalDevices.push(node);
				} else if (node.DeviceRole === ENDPOINT_DEVICE || node.MainSensorType != "none") {
					measuringDevices.push(node);
				} else if ((Object.values(INFRASTRUCTURE_DEVICES) as string[]).includes(node.DeviceRole)) {
					infrastructureDevices.push(node);
				} else {
					unknownDevices.push(node);
				}
				//check if node is accelerated to display on a snackbar
				if ( Date.parse(node.AcceleratedUntil) > Date.now()) {
					acceleratedNodesNames.push(node.name);
				}
			});
			if (currentSystem) {
				let renderNodeCards = () => {
					if (!isNodesLoading) {
						return (
							<NodeCards
								classes={this.props.classes}
								exportStart={this.state.exportStart}
								exportStop={this.state.exportStop}
								infrastructureDevices={infrastructureDevices}
								measuringDevices={measuringDevices}
								mobileView={mobileView}
								setCurrentNodeID={this.props.setCurrentNodeID}
								system={currentSystem}
								nonoperationalDevices={nonoperationalDevices}
								unknownDevices={unknownDevices}
								dashboardFilteredNodes={dashboardFilteredNodes}
								deleteNodeSuccessfully={this.props.deleteNodeSuccessfully}
							/>
						);
					} else {
						return <MapLoading testID='nodeShortStatusLoaderContainer' />;
					}
				};
                return (
                    <ErrorComponent message='Corrupted dashboard data' Children>
                        <GridContainer data-testid='Dashboard'>
                            <GridItem key={'system-status'} xs={12}>
                                <ShortStatus linkDisabled={true} system={currentSystem} showBigWeatherCard={true} 
											 showSystemDocumentation={true} systemFiles={systemFiles} showRainstormMode={true} showServiceMode={true}
											 showTestNotication={true} showW2Website={true} showSystemGraph={true} showResetSensorErrors={true} showNotifications={true}/>
                            </GridItem>
                            <GridItem key={'heat-map'} xs={12}>
                                <Card>
                                    <CardHeader color='info' icon>
                                        <WiseneCardIcon color={colorMap[currentSystem.NodesHighestThreatLevelActiveNonobstructed]}>
                                            <Map />
                                        </WiseneCardIcon>
                                        <p className={classes.cardCategory}>System map</p>
                                    </CardHeader>
                                    <ErrorComponent message='Corrupted heat map data' Children>
                                        <HeatMap
											systemId={currentSystem.ID}
                                            mapHeight={currentSystem.mapSizeY}
                                            mapWidth={currentSystem.mapSizeX}
                                            isMapLoading={isMapLoading}
                                            mapBoundaries={parseMapBoundaries(currentSystem.mapObjectsBoundaries)}
                                            nodes={nodes}
                                            mobileView={mobileView}
                                            setCurrentNodeID={this.props.setCurrentNodeID}
                                            mainMapDataBlob={systemMapDataBlob}
                                        />
                                    </ErrorComponent>
                                    <CardFooter />
                                </Card>
                                {renderNodeCards()}
                                {!mobileView
                                    ? noMeasurementsWarnings.map((currentWarningId) => {
                                        const nodeName = this.props.nodes.filter((node) => node.id === currentWarningId)[0].name;
                                        if (nodeName) {
                                            this.warningTimeout = setTimeout(() => {
                                                closeNoMeasurementsWarning(currentWarningId);
                                            }, 6000);
                                        }
                                        return (
                                            <Snackbar
                                                close
                                                closeNotification={() => closeNoMeasurementsWarning(currentWarningId)}
                                                color='warning'
                                                message={`No measurements for ${nodeName} in this range`}
                                                open={noMeasurementsWarnings.length > 0}
                                                place='tc'
                                            />
                                        );
                                    })
                                : null}
                              {
                              isRecalculated && Object.keys(isRecalculated).length ?
                                Object.keys(isRecalculated).map(key => {
                                    const isNodeRecalculated = isRecalculated[key];
                                    return (
                                    <>
                                      <Snackbar
                                        close
                                        closeNotification={() => closeNodeRecalculatedNotification(key)}
                                        color='success'
                                        message={`${key} updated`}
                                        open={isNodeRecalculated}
                                        place='tc'
                                      />
                                      <Snackbar
                                        close
                                        closeNotification={() => closeNodeWillRecalculateNotification(key)}
                                        color='success'
                                        message={`${key} will update shortly`}
                                        open={!isNodeRecalculated}
                                        place='tc'
                                      />
                                      {this.warningTimeout = setTimeout(() => {
                                        if (isNodeRecalculated) {
                                          closeNodeRecalculatedNotification(key);
                                        } else {
                                          closeNodeWillRecalculateNotification(key);
                                        }
                                      }, 6000)}
                                    </>
                                    )
                                }) : null
                              }
                              {accelerateSucceeded ?
                                <>
                                  <Snackbar
                                    close
                                    closeNotification={() => closeNodeAcceleratedNotification()}
                                    color='success'
                                    message={'Node is now in an accelerated mode'}
                                    open={accelerateSucceeded && !!nodeAcceleratedUntil}
                                    place='tc'
                                  />
                                  <Snackbar
                                    close
                                    closeNotification={() => closeNodeAcceleratedNotification()}
                                    color='success'
                                    message={'Acceleration mode canceled'}
                                    open={accelerateSucceeded && !nodeAcceleratedUntil}
                                    place='tc'
                                  />
                                  {this.warningTimeout = setTimeout(() => {
                                    closeNodeAcceleratedNotification();
                                  }, 6000)}
                                </> : null
                              }
							  {acceleratedNodes && acceleratedNodesNames.length ?
                                <>
								<Snackbar
								  close
								  closeNotification={() => closeAcceleratedNodesNotification()}
								  color='success'
								  message={acceleratedNodesNames.length == 1 
									? `Node ${acceleratedNodesNames.join(", ")} is in an accelerated mode`
									: `Nodes ${acceleratedNodesNames.join(", ")} are in an accelerated mode`}
								  open={acceleratedNodes && acceleratedNodesNames.length > 0}
								  place='tc'
								/>
								{this.warningTimeout = setTimeout(() => {
								  closeAcceleratedNodesNotification();
								}, 6000)}
							  </> : null
							  }
							  {(rainstormModeSettingFailed || rainstormModeSettingSuccess) ?
								<>
								{!mobileView && <Snackbar
									close
									closeNotification={() => closeSettingRainstormModeNotification()}
									color={rainstormModeSettingFailed ? 'danger' : 'success'}
									message={rainstormModeSettingFailed
										? 'Setting rainstorm mode failed' + (rainstormModeSettingFailedReason ? ': ' + rainstormModeSettingFailedReason : '')
										: 'Rainstorm mode turned ' + (system.rainstormModeNow ? 'on' : 'off')}
									open={rainstormModeSettingFailed || rainstormModeSettingSuccess}
									place='tc'
								/>}
								{this.warningTimeout = setTimeout(() => {
									closeSettingRainstormModeNotification();
								}, 6000)}
								</> : null}
								{(testNotificationFailed || testNotificationSuccess) ?
								<>
								{!mobileView && <Snackbar
									close
									closeNotification={() => closeSendTestNotificationNotification()}
									color={testNotificationFailed ? 'danger' : 'success'}
									message={testNotificationFailed
										? 'Adding test notification failed'
										: 'Test notification added successfully'}
									open={testNotificationFailed || testNotificationSuccess}
									place='tc'
								/>}
								{this.warningTimeout = setTimeout(() => {
									closeSendTestNotificationNotification();
								}, 6000)}
								</> : null}
							  {(serviceModeSettingFailed || serviceModeSettingSuccess) ?
								<>
								{!mobileView && <Snackbar
									close
									closeNotification={() => closeSettingRainstormModeNotification()}
									color={serviceModeSettingFailed ? 'danger' : 'success'}
									message={serviceModeSettingFailed
										? 'Setting service mode failed' + (rainstormModeSettingFailedReason ? ': ' + rainstormModeSettingFailedReason : '')
										: 'Service mode turned ' + (!!system.serviceModeEnd ? 'on' : 'off')}
									open={serviceModeSettingFailed || serviceModeSettingSuccess}
									place='tc'
								/>}
								{this.warningTimeout = setTimeout(() => {
									closeSettingServiceModeNotification();
								}, 6000)}
								</> : null}
							  {(settingNotificationsFailed || settingNotificationsSuccess) ?
								<>
								{!mobileView && <Snackbar
									close
									closeNotification={() => closeSettingSystemNotificationsNotification()}
									color={settingNotificationsFailed ? 'danger' : 'success'}
									message={settingNotificationsFailed
										? 'Setting System notifications failed'
										: 'System notifications settings saved'}
									open={settingNotificationsFailed || settingNotificationsSuccess}
									place='tc'
								/>}
								{this.warningTimeout = setTimeout(() => {
									closeSettingSystemNotificationsNotification();
								}, 6000)}
								</> : null}
							  {(resetSensorErrorCountsFailed || resetSensorErrorCountsSuccess) ?
								<>
								{!mobileView && <Snackbar
									close
									closeNotification={() => closeResetSensorErrorCountsNotification()}
									color={resetSensorErrorCountsFailed ? 'danger' : 'success'}
									message={resetSensorErrorCountsFailed
										? 'Resetting sensor error counters failed'
										: 'Sensor error counters reset'}
									open={resetSensorErrorCountsFailed || resetSensorErrorCountsSuccess}
									place='tc'
								/>}
								{this.warningTimeout = setTimeout(() => {
									closeResetSensorErrorCountsNotification();
								}, 6000)}
								</> : null}
                            </GridItem>
                        </GridContainer>
                    </ErrorComponent>
                );
			} else {
				return <EmptyCard />;
			}
		} catch (error) {
			console.log('ERROR_DEBUG', error);
			return <ErrorText message='Corrupted map data.'></ErrorText>;
		}
	}
}

const mapStateToProps = (state) => {
	return {
		isMapLoading: state.dashboard.isMapLoading,
		isNodesLoading: state.dashboard.isNodesLoading,
		isEditing: state.dashboard.isEditing,
		nodes: state.dashboard.nodes,
		system: state.dashboard.system,
		forbidden: state.dashboard.forbidden,
		noMeasurementsWarnings: state.dashboard.noMeasurementsWarnings,
		mobileView: state.dashboard.mobileView,
		dashboardFilteredNodes: state.dashboard.dashboardFilteredNodes,
		deleteNodeSuccessfully: state.installer.deleteNodeSuccessfully,
		isRecalculated: state.dashboard.isRecalculated,
		systemMapDataBlob: state.dashboard.systemMapDataBlob,
		accelerateSucceeded: state.dashboard.accelerateSucceeded,
		nodeAcceleratedUntil: state.dashboard.nodeAcceleratedUntil,
		acceleratedNodes: state.dashboard.acceleratedNodes,
		systemFiles: state.dashboard.systemFiles,
		rainstormModeSettingSuccess: state.dashboard.rainstormModeSettingSuccess,
		rainstormModeSettingFailed: state.dashboard.rainstormModeSettingFailed,
		rainstormModeSettingFailedReason: state.dashboard.rainstormModeSettingFailedReason,
		serviceModeSettingSuccess: state.dashboard.serviceModeSettingSuccess,
		serviceModeSettingFailed: state.dashboard.serviceModeSettingFailed,
		testNotificationSuccess: state.dashboard.testNotificationSuccess,
		testNotificationFailed: state.dashboard.testNotificationFailed,
		settingNotificationsSuccess: state.dashboard.settingNotificationsSuccess,
		settingNotificationsFailed: state.dashboard.settingNotificationsFailed,
		resetSensorErrorCountsSuccess: state.dashboard.resetSensorErrorCountsSuccess,
		resetSensorErrorCountsFailed: state.dashboard.resetSensorErrorCountsFailed
	};
};
const actions = {
	dashboardData,
	clearDashboardData,
	setCurrentNodeID,
	closeNoMeasurementsWarning,
	closeNodeRecalculatedNotification,
	closeNodeWillRecalculateNotification,
	closeNodeAcceleratedNotification,
	closeAcceleratedNodesNotification,
	checkScreenSize,
	closeSettingRainstormModeNotification,
	closeSendTestNotificationNotification,
	closeSettingServiceModeNotification,
	closeSettingSystemNotificationsNotification,
	closeResetSensorErrorCountsNotification
};

const dashboardWithStyles = dashboardStyle(Dashboard);
const connectedDashboard = connect(mapStateToProps, actions)(dashboardWithStyles);
export default withRouter(connectedDashboard);